var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"18","viewBox":"0 0 16 18"}},[_c('path',{attrs:{"fill":"#516783","d":"M16 9 0 18V0Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }